
   // --- Title Wrapper Section ---

   window.addEventListener('scroll', function() {
    const scrollPos = window.pageYOffset;
    const maxScroll = 500;
    const t = Math.min(scrollPos / maxScroll, 1);
    const initialMargin = (window.innerWidth > 750)? 20 : 14;
    // const newMargin = initialMargin * (1 - t);
    // const newOpacity = 1 - (t * 2);
    const dynamicHeader = document.querySelector('.dynamic_header_title_wrapper');
    if (scrollPos > 0) {
      dynamicHeader.style.marginTop =  '-10rem';
      dynamicHeader.style.opacity = 0
    } else {
      dynamicHeader.style.marginTop = initialMargin + 'rem';
      dynamicHeader.style.opacity = 1
    }
  });
  // --- Top Title Section ---
      window.addEventListener('load', () => {
    setTimeout(() => {
        document.querySelector('.dynamic_header_top_title').style.opacity = 1;
      }, 700);
  });
  
  // --- Title Section ---
    window.addEventListener('load', () => {
    const words = document.querySelectorAll('.word');
    words.forEach((word) => {
      const delay = parseInt(word.dataset.threshold, 10) * 20;
      setTimeout(() => {
        word.classList.add('visible');
      }, delay);
    });
  });
    

  // --- Subtitle Section ---
    window.addEventListener('load', () => {
    setTimeout(() => {
        document.querySelector('.sub_title').style.opacity = 1;
      }, 700);
  });


  // --- Images Section ---


  function getRem(text) {
    const regex = /translateX\(\s*([-+]?[0-9]*\.?[0-9]+)\s*rem\s*\)/;
    const match = text.match(regex);
    return match ? parseFloat(match[1]) : null;
  }

  function isReadyToMove(selector, scrollRem) {
    if ( scrollRem > 50) return
    let remValue = getRem(document.querySelector(selector).style.transform)
    if (Math.abs(remValue) > 30) {
      return ((Math.abs(remValue) - 25))
    } else {
      return 0
    }
  }


   window.addEventListener('load', function() {

     document.querySelector('.dynamic_images_wrapper').style.opacity = 1;
      //Left
      document.querySelector('.dynamic_images_wrapper img.left1').style.transform = `translateX(80rem)`;
      document.querySelector('.dynamic_images_wrapper img.left2').style.transform = `translateX(55rem)`;
      document.querySelector('.dynamic_images_wrapper img.left3').style.transform = `translateX(30rem)`;
     //Right
      document.querySelector('.dynamic_images_wrapper img.right1').style.transform = `translateX(-80rem)`;
      document.querySelector('.dynamic_images_wrapper img.right2').style.transform = `translateX(-55rem)`;
      document.querySelector('.dynamic_images_wrapper img.right3').style.transform = `translateX(-30rem)`;
   });
   window.addEventListener('scroll', () => {
    const rem = 16; 
    const scrollRem = window.scrollY / rem;
    let offset = 0;
    if (scrollRem > 25) {
      offset = scrollRem - 25;
    }
    if ( scrollRem > 50) return
    //Left
    document.querySelector('.dynamic_images_wrapper img.left1').style.transform = `translateX(${80 + scrollRem}rem )`
    document.querySelector('.dynamic_images_wrapper img.left2').style.transform = `translateX(${55 + scrollRem}rem )`
    document.querySelector('.dynamic_images_wrapper img.left3').style.transform = `translateX(${30 + scrollRem}rem )`
    document.querySelector('.dynamic_images_wrapper img.left4').style.transform = `translateX(${isReadyToMove('img.left3', scrollRem)}rem )`
    document.querySelector('.dynamic_images_wrapper img.left5').style.transform = `translateX(${isReadyToMove('img.left4', scrollRem)}rem )`
    
    //Right
    
    document.querySelector('.dynamic_images_wrapper img.right1').style.transform = `translateX(-${80 + scrollRem}rem )`
    document.querySelector('.dynamic_images_wrapper img.right2').style.transform = `translateX(-${55 + scrollRem}rem )`
    document.querySelector('.dynamic_images_wrapper img.right3').style.transform = `translateX(-${30 + scrollRem}rem )`
    document.querySelector('.dynamic_images_wrapper img.right4').style.transform = `translateX(-${isReadyToMove('img.right3', scrollRem)}rem )`
    document.querySelector('.dynamic_images_wrapper img.right5').style.transform = `translateX(-${isReadyToMove('img.right4', scrollRem)}rem )`

  });
